import { Component, OnInit, Input } from '@angular/core';
import { FIVE_HUNDRED_RANK, FIVE_THOUSAND_RANK, ONE_HUNDRED_RANK, ONE_THOUSAND_RANK } from '../../../utils/club-trader-constant';

@Component({
  selector: 'rank-trader',
  templateUrl: './rank-trader.component.html',
  styleUrls: ['./rank-trader.component.scss'],
})
export class RankTraderComponent implements OnInit {
  
  @Input() public rankingPosition: number;
  @Input() public typeProfile: string;
  @Input() public rankingMonth: Date;
  readonly today = new Date();
  public block: string;
  public typeTrader: string;
  public cssBackground: string;
  public topRank: string;
  public svgUnlock: string;

  constructor() {
    /** */
  }

  ngOnInit() { 
    this.initializeRank();
  }

  private initializeRank = (): void => {
    try { 
      this.block = this.getBlock();
      this.typeTrader = this.getTypeTrader();
      this.cssBackground = this.getCssBackground();
      this.topRank = this.getTopRank();
      this.svgUnlock = this.getSvgUnblock();
    } catch {
      this.block = '-block';
      this.typeTrader = '';
      this.cssBackground = '';
      this.topRank = '5.000';
      this.svgUnlock = 'stock/assets/icons/padlock.svg';
    }
  }

  private getBlock =  (): string => this.rankingPosition > FIVE_THOUSAND_RANK ? '-block' : '';

  private getTypeTrader = (): string => {
    const inClub = !!this.typeProfile && this.typeProfile.toString().indexOf('TRADER') >= 0;
    return inClub ? this.typeProfile.replace('TRADER_', '').toLocaleLowerCase() : 'starter'
  };

  private getCssBackground = (): string => this.showPosition() && this.rankingPosition <= FIVE_THOUSAND_RANK && this.rankingPosition !== 0 ? `${this.getTypeTrader()}-back` : '';

  private getTopRank = (): string => {
    if(!this.showPosition()) return '5.000';
    else if (this.rankingPosition <= ONE_HUNDRED_RANK) return '100';
    else if (this.rankingPosition <= FIVE_HUNDRED_RANK) return '500';
    else if (this.rankingPosition <= ONE_THOUSAND_RANK) return '1.000';
    else if (this.rankingPosition <= FIVE_THOUSAND_RANK || this.rankingPosition > FIVE_THOUSAND_RANK || this.rankingPosition === 0) return '5.000';
    else return '5.000'    
  }

  public showPosition = (): boolean => 
    this.today.getFullYear() === this.rankingMonth.getFullYear() && this.today.getMonth() === this.rankingMonth.getMonth();
    
  private getSvgUnblock = (): string => {
    if (this.rankingPosition === 0 || !this.showPosition()) {
      return 'stock/assets/icons/padlock.svg';
    }
    else if (this.rankingPosition <= FIVE_THOUSAND_RANK) {
      if (this.typeProfile === 'TRADER_STARTER' || this.typeProfile === 'DEFAULT') {
        return 'stock/assets/icons/star.svg';
      } else {
        return 'stock/assets/icons/star_white.svg';
      }
    } else {
      return 'stock/assets/icons/padlock.svg';
    }
  }
}
